/**
 * @desc 分页
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  defs.appCenter.IPage<defs.appCenter.ViewTableResponseDto>
>;
export function request(
  params: API.appCenter.viewTable.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/viewTable/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
